<template>
  <div>
    <Pane :title="detail.name" />

    <div class="container">
      <div class="card">
        <a-form
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 10 }"
          :colon="false"
        >
          <a-row>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item label="累计确认进度">
                {{progress}}%
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item label="开票金额(万元)">
                <a-input type="number" v-model="detail.conInvoiceSum" />
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item label="回款金额(万元)">
                <a-input type="number" v-model="detail.conPaymentSum" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item label="项目状态" style="display: flex;align-items: center">
                <div style="display: flex;align-items: center">
                  <a-select
                  @change="onStatusChange"
                  v-model="detail.conProjectStatus"
                  placeholder="请选择"
                  style="width: 200px;margin-right: 10px"
                >
                  <a-select-option
                    v-for="item in statusList"
                    :key="item.value"
                    :value="item.value"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
                <a-select
                  v-if="detail.conProjectStatus === 'adjust_contract' || detail.conProjectStatus === 'risk_contract'"
                  v-model="detail.conProjectStatusSub"
                  placeholder="请选择"
                  style="width: 200px"
                >
                  <a-select-option
                    v-for="item in statusListB"
                    :key="item.key"
                    :value="item.value"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="card">
        <div class="title" style="margin-bottom: 10px">分包</div>
        <a-table bordered :data-source="list" :pagination="false" rowKey="id">
          <a-table-column title="分包名称" data-index="name" />
          <a-table-column title="分包属性">
            <template slot-scope="text">
              <span v-if="text.isneeded === 1">设计类-必要分包</span>
              <span v-if="text.isneeded === 0">设计类-非必要分包</span>
              <span v-if="text.isneeded === 2">总承包类分包</span>
            </template>
          </a-table-column>
          <a-table-column title="分包类别">
            <template slot-scope="text">
              <DataDictFinder dictType="subType" :dictValue="text.type" />
              <DataDictFinder dictType="notNeedSubType" :dictValue="text.type" />
              <DataDictFinder dictType="generalSubType" :dictValue="text.type" />
            </template>
          </a-table-column>

          <a-table-column title="分包方" data-index="companyName" />
          <a-table-column title="分包状态" align="center">
            <template slot-scope="text">
              <DataDictFinder dictType="subpackageStatus" :dictValue="text.status" iconType="text" />
            </template>
          </a-table-column>
          <a-table-column title="已支付金额(万)" align="right">
            <template slot-scope="text">
              <a-input v-if="text.editable" type="number" v-model="text.paymentAmount" size="small" style="width: 80px" />
              <span v-else> <Money :money="text.paymentAmount" /></span>
            </template>
          </a-table-column>
          <a-table-column title="预算金额(万)" align="right">
            <template slot-scope="text">
              <Money :money="text.planAmount" />
            </template>
          </a-table-column>

          <a-table-column title="操作" align="center">
            <template slot-scope="text, record, index">
              <a-space>
                <a href="#" @click.prevent="openDetail(text)">查看</a>
                <a href="#" v-if="!text.editable" @click.prevent="editText(index)">编辑</a>
                <a href="#" v-if="text.editable" @click.prevent="saveText(index)">保存</a>
              </a-space>
            </template>
          </a-table-column>
        </a-table>
      </div>
      <div class="card">
            <div class="title">收款项明细</div>
            <Padding />

            <a-alert
              style="margin-bottom: 8px"
              :message="receiptMessage"
              type="info"
              show-icon
            />

            <a-table
              bordered
              :data-source="receiptList"
              :pagination="false"
              rowKey="id"
            >
              <a-table-column
                title="编号"
                data-index="code"
                align="center"
                width="50px"
              />
              <a-table-column title="收款项名称" data-index="name" />
              <a-table-column title="收款金额(元)" align="right">
                <template slot-scope="text">
                  <span v-if="parseFloat(text.planReceipt) < 0" style="color: #f00">{{
                    parseFloat(text.planReceipt).toLocaleString()
                  }}</span>
                  <span v-else style="color: #1890ff">{{
                    parseFloat(text.planReceipt).toLocaleString()
                  }}</span>
                </template>
              </a-table-column>
              <a-table-column title="收款比例(%)" data-index="ratio" align="right" />
              <a-table-column title="是否确认" align="center">
                <template slot-scope="text">
                  <a-checkbox v-model="text.isFinished"/>
                </template>
              </a-table-column>
            </a-table>
        <div class="center" style="margin: 30px 0">
          <a-space>
            <a-button @click="$close($route.path)">关闭</a-button>
            <a-button type="primary" @click="save" :loading="saveLoading">确认修改</a-button>
          </a-space>
        </div>  
      </div>

    </div>
  </div>
</template>

<script>
import watermark from "@/mixins/watermark";

import Info from "./components/info.vue";
import Dashboard from "./components/dashboard.vue";
import Contract from "./components/contract.vue";
import Subpackage from "./components/subpackage.vue";
import Progress from "./components/progress.vue";
import Statistic from "./components/statistic/index.vue";
import Files from "./components/files.vue";
import { fetchDetail,fetchBill,fetchSubpackage,editProjectOverview } from "@/api/project/overview";
import { mapGetters } from "vuex";
export default {
  mixins: [watermark],

  components: {
    Info,
    Dashboard,
    Contract,
    Subpackage,
    Progress,
    Statistic,
    Files,
  },

  data() {
    return {
      detail: {},
      info: {},
      selectedContractId: null,
      statusListB: [],
      saveLoading: false,
      list: [],
      progress: 0,
    };
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    statusList() {
      return this.findDataDict("con_prj_status");
    },
    receiptList() {
      return Array.isArray(this.info.receiptList) ? this.info.receiptList : [];
    },
    receiptMessage() {
      const list = this.receiptList.filter((item) => item.isFinished);
      let ratio = 0;
      let money = 0;
      list.forEach((item) => {
        if (typeof item.ratio === "number") {
          ratio += item.ratio;
        }
        if (typeof item.planReceipt === "number") {
          money += item.planReceipt;
        }
      });

      return `已确认 ${
        list.length
      } 项； 总确认度 ${ratio} %； 确认金额：${money.toLocaleString()} 元`;
    },
  },
  methods: {    
    editText(index) {
      this.list.splice(index, 1, {
        ...this.list[index],
        paymentAmount: this.list[index].paymentAmount / 10000,
        editable: true,
      });
    },
    saveText(index) {
      const item = this.list[index];
      this.list.splice(index, 1, {
        ...item,
        paymentAmount: parseInt(item.paymentAmount * 10000),
        editable: false,
      });
    },
    onStatusChange(text) {
      this.detail.conProjectStatusSub = ''
      if(text == 'adjust_contract'){
        this.statusListB = this.findDataDict('con_prj_status.adjust_contract')
      }else if(text == 'risk_contract'){
        this.statusListB = this.findDataDict('con_prj_status.risk_contract')	
      }else{
        this.statusListB = []
      }
    },
    save() {
      let canSave = true;
      this.list.forEach((item) => {
        if(item.editable){
            canSave = false;
        }
      })
      if(!canSave){
        this.$message.error("请先保存分包信息");
        return;
      }
      this.saveLoading = true;
      const data = {
        id: this.selectedContractId,
        code: this.detail.code,
        conInvoiceSum: this.detail.conInvoiceSum,
        conPaymentSum: this.detail.conPaymentSum,
        conProjectStatus: this.detail.conProjectStatus,
        conProjectStatusSub: this.detail.conProjectStatusSub,
        subList: this.list.map((item) => {
          return {
            id: item.id,
            name: item.name,
            paymentAmount: item.paymentAmount,            
          };
        }),
        receiptList: this.receiptList.map((item) => {
          return {
            id: item.id,
            name: item.name,
            isFinished: item.isFinished ? 1 : 0,
          };
        }),
      };
      editProjectOverview(data)
       .then(() => {
          this.$message.success("修改成功");
          this.$close();
        })
       .catch(() => {
          this.$message.error("修改失败");
        })
       .finally(() => {
          this.saveLoading = false;
        });
    }
  },
  mounted() {
    const { query } = this.$route;
    const { id } = query || {};
    fetchDetail({
      id,
    }).then((res) => {
      this.detail = res;
      this.progress = this.detail.contractList[0].projectList[0].progress;
      this.selectedContractId = id;
      if(this.detail.conProjectStatus == 'adjust_contract'){
        this.statusListB = this.findDataDict('con_prj_status.adjust_contract')
      }else if(this.detail.conProjectStatus == 'risk_contract'){
        this.statusListB = this.findDataDict('con_prj_status.risk_contract')	
      }else{
        this.statusListB = []
      }
    });
    fetchBill({
        id,
      })
        .then((res) => {
          this.info = res ?? {};
          this.info.receiptList.forEach((item) => {
            if(item.isFinished === 1){
              item.isFinished = true
            }else{ 
              item.isFinished = false
            }
          });
        });
    fetchSubpackage({
      id,
    })
      .then((res) => {
        if (Array.isArray(res)) {
          this.list = res;
        }
      });    
  },
};
</script>

<style lang="less" scoped>
.card {
  background-color: #fff;
  margin-bottom: 8px;
  padding: 8px;
}
.title {
  font-weight: bold;
  font-size: 13px;
}
</style>